import { render, staticRenderFns } from "./SelectPage.vue?vue&type=template&id=70f8c78a&scoped=true&"
import script from "./SelectPage.vue?vue&type=script&lang=js&"
export * from "./SelectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f8c78a",
  null
  
)

export default component.exports